import { Box } from "@chakra-ui/react";
import Layout from "../components/Layout";
import LastNews from "../components/LastNews";
import About from "../components/About";
import Help from "../components/Help";
import Contacts from "../components/Contacts";
import SponsorBanner from "../components/SponsorBanner";

const Home = () => {
  return (
    <Layout>
      <Box>
        <LastNews />
        <About />
        <Help />
        <SponsorBanner />
        <Contacts />
      </Box>
    </Layout>
  );
};

export default Home;
